<template>
  <ModalSmall :title="textTitle" @close="closeModalSurvey()" class="self-service-survey-modal">
    <!--구독취소 기존 버전-->
    <div class="container-survey" v-if="isUnsubscribe">
      <p>{{ t('ss_survey_unsubscribe') }}</p>
      <div class="wrapper-label">
        <label
          class="radio-option"
          v-for="(optionUnsubscribe, indexUnsubscribe) in optionsRadioUnsubscribe"
          :key="indexUnsubscribe"
        >
          <input type="radio" :value="optionUnsubscribe.value" v-model="answer" />
          <div class="radio-box radio-box-gray">
            {{ optionUnsubscribe.label }}
          </div>
        </label>
        <textarea
          v-if="isSelectedOther"
          v-model="answerOther"
          @compositionstart="isComposing = true"
          @compositionend="isComposing = false"
        ></textarea>
      </div>
    </div>

    <!-- <div class="container-survey mb-7" v-if="isUnsubscribe">
      <div class="txt-box pd-vertical-6">
        <div class="tit-h5 mb-2">Pro 구독을 취소할까요?</div>
        <span class="dim">구독을 취소하는 이유를 알려주시면 더 나은 서비스 개선에 참고하겠습니다.</span>
      </div>
      <div class="basic-select">
        <select class="l-select" name="" id="">
          <option value="" disabled selected hidden>구독을 취소하려는 이유는 무엇인가요?</option>
          <option value="">현재 요금이 제 상황에 맞지 않아요.</option>
          <option value="">당분간 사용할 일이 없거나 서비스를 많이 사용하지 않아요.</option>
          <option value="">다른 서비스를 이용할 예정이에요.</option>
          <option value="">필요한 기능이 부족하거나, 사용 중 오류나 문제가 자주 발생합니다.</option>
          <option value="">직접 작성</option>
        </select>
      </div>
    </div> -->

    <!--계정삭제-->
    <div class="container-survey" v-if="isDeleteAccount">
      <p>{{ t('ss_survey_delete_account_question') }}</p>
      <div class="wrapper-label">
        <label class="radio-option" v-for="(optionDelete, indexDelete) in optionsRadioDeleteAccount" :key="indexDelete">
          <input type="radio" :value="optionDelete.value" v-model="answer" />
          <div class="radio-box">
            {{ optionDelete.label }}
          </div>
        </label>
        <textarea
          v-if="isSelectedOther"
          v-model="answerOther"
          @compositionstart="isComposing = true"
          @compositionend="isComposing = false"
        ></textarea>
      </div>
    </div>

    <ButtonProcess @click="onClickSubmit" :disabled="isDisabledSubmit" full-width>
      {{ t('button_confirm') }}
    </ButtonProcess>
  </ModalSmall>
</template>

<script setup lang="ts">
import { submitSurveyAnswer } from '@/api/apiService';
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { useModalAccountDelete } from '@/composables/domains/self-service/useModalAccountDelete';
import { useModalSurvey } from '@/composables/domains/self-service/useModalSurvey';
import { usePayment } from '@/composables/shared/usePayment';
import { IRequestSubmitSurvey } from '@/types/request';

const { t } = useI18n();
const { typeSurvey, closeModalSurvey } = useModalSurvey();
const { openModalAccountDelete } = useModalAccountDelete();
const { handleSubscriptionCancel } = usePayment();

const answer = ref('');
const answerOther = ref('');
const isComposing = ref(false);

const isDeleteAccount = computed(() => {
  return typeSurvey.value === 'DELETE_ACCOUNT';
});

const isUnsubscribe = computed(() => {
  return typeSurvey.value === 'CANCEL_SUBSCRIPTION';
});

const textTitle = computed(() => {
  if (isUnsubscribe.value) {
    return t('self_service_subscription_cancel');
  }

  if (isDeleteAccount.value) {
    return t('button_account_delete');
  }

  return '';
});

const optionsRadioUnsubscribe = computed(() => {
  return [
    {
      label: t('ss_survey_unsubscribe_answer_situation'),
      value: t('ss_survey_unsubscribe_answer_situation', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_unsubscribe_answer_usage'),
      value: t('ss_survey_unsubscribe_answer_usage', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_unsubscribe_answer_alternative'),
      value: t('ss_survey_unsubscribe_answer_alternative', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_unsubscribe_answer_feature'),
      value: t('ss_survey_unsubscribe_answer_feature', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_answer_compose'),
      value: t('ss_survey_answer_compose', {}, { locale: 'ko' }),
    },
  ];
});

const optionsRadioDeleteAccount = computed(() => {
  return [
    {
      label: t('survey_delete_account_plan'),
      value: t('survey_delete_account_plan', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_delete_account_security'),
      value: t('ss_survey_delete_account_security', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_delete_account_history'),
      value: t('ss_survey_delete_account_history', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_unsubscribe_answer_account'),
      value: t('ss_survey_unsubscribe_answer_account', {}, { locale: 'ko' }),
    },
    {
      label: t('ss_survey_answer_compose'),
      value: t('ss_survey_answer_compose', {}, { locale: 'ko' }),
    },
  ];
});

const isSelectedOther = computed(() => {
  return answer.value === t('ss_survey_answer_compose', {}, { locale: 'ko' });
});

const isDisabledSubmit = computed(() => {
  const isEmptyAnswer = !answer.value;
  const isEmptyAnswerOther = isSelectedOther.value && !answerOther.value;
  if (isComposing.value) return false;
  return isEmptyAnswer || isEmptyAnswerOther;
});

const onClickSubmit = async () => {
  const answerParam = isSelectedOther.value ? answerOther.value : answer.value;

  const params: IRequestSubmitSurvey = {
    surveyType: typeSurvey.value!,
    answer: answerParam,
  };

  const resSurvey = await submitSurveyAnswer(params);
  if (resSurvey.success) {
    closeModalSurvey();

    if (isDeleteAccount.value) {
      openModalAccountDelete();
    }

    if (isUnsubscribe.value) {
      handleSubscriptionCancel();
    }
  }
};
</script>

<style scoped lang="scss">
.self-service-survey-modal {
  z-index: 1501;
}

.container-survey {
  text-align: center;
  > p {
    font-size: $font-size-h6;
    font-weight: 600;
  }
  .txt-box {
    .dim {
      margin: 0 auto;
      display: block;
      max-width: 240px;
    }
  }
}

.wrapper-label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 0;
  .radio-option {
    width: 100%;
    input[type='radio'] {
      &:checked {
        + .radio-box {
          color: #fff !important;
          background: $color-navy-100 !important;
          box-shadow: none;
        }
      }
    }
    .radio-box {
      border-radius: 0.5rem;
      width: 100%;
      text-align: left;
    }
  }
}

.radio-box {
  white-space: pre-wrap !important;
}
</style>
